import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const hotArticles = articles.filter((a) => a.isHot);
  const exclusiveArticles = articles.filter((a) => a.isExclusive);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '17吃瓜网',
        url: 'http://1wujie.cn/',
        description: '17吃瓜网官网汇集全网热门吃瓜爆料、网红黑料、明星塌房事件，每日更新最新猛料。',
        foundingDate: '2019',
        sameAs: ['http://1wujie.cn/'],
      },
      {
        '@type': 'WebSite',
        name: '17吃瓜网',
        url: 'http://1wujie.cn/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://1wujie.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '17吃瓜网 - 首页',
        description: '17吃瓜网官网汇集全网热门吃瓜爆料、网红黑料、明星塌房事件，每日更新最新猛料。',
        url: 'http://1wujie.cn/',
        isPartOf: { '@id': 'http://1wujie.cn/#website' },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      {/* Hero Section */}
      <section className="relative w-full min-h-[500px] md:min-h-[640px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20coral%20pink%20and%20deep%20teal%20gradients%2C%20geometric%20overlapping%20shapes%2C%20soft%20diffused%20lighting%2C%20modern%20editorial%20design%20background%2C%20clean%20minimal%20composition%2C%20subtle%20texture%2C%20cinematic%20atmosphere%2C%20luxurious%20feel%2C%20no%20text%20no%20people&width=1920&height=900&seq=home-hero-bg&orientation=landscape"
            alt="17吃瓜网 - 热门爆料"
            title="17吃瓜网 - 每日新鲜大瓜"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

        <div className="relative z-10 w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
            <div className="lg:w-[42%] text-center lg:text-left">
              <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-label rounded-full mb-4">
                今日头瓜
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 leading-tight">
                {hotArticles[0]?.title || '顶流网红背后资本交易内幕曝光'}
              </h1>
              <p className="mt-4 text-base md:text-lg text-background-50/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
                {hotArticles[0]?.excerpt || '据知情人士透露，某拥有三千万粉丝的顶流网红背后存在复杂的资本运作网络...'}
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <Link
                  to={`/article/${hotArticles[0]?.slug || 'dingji-wanghong-beihou-ziben-jiaoyi-neimu'}`}
                  className="px-6 py-3 bg-primary-500 text-background-50 font-label text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  查看详情 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
                <Link
                  to={`/category/${hotArticles[0]?.categorySlug || 'wanghong-heidiao'}`}
                  className="px-6 py-3 border border-background-50/30 text-background-50 font-label text-sm rounded-lg hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  更多{hotArticles[0]?.category || '网红黑料'}
                </Link>
              </div>
            </div>
            <div className="lg:w-[58%] hidden lg:block">
              <div className="relative rounded-3xl overflow-hidden bg-foreground-900/40 backdrop-blur-sm p-4">
                <div className="grid grid-cols-3 gap-4">
                  {articles.slice(1, 4).map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group cursor-pointer"
                    >
                      <div className="rounded-xl overflow-hidden h-[140px]">
                        <img
                          src={article.imageUrl}
                          alt={article.title}
                          title={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <p className="mt-2 text-xs text-background-50/80 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                        {article.title}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 最新爆料 - Horizontal Scroll */}
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 border border-background-300 text-foreground-600 text-xs font-label rounded-full">
            实时追踪
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            最新爆料
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            每日更新，不放过任何一个大瓜
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {articles.map((article, index) => (
            <ArticleCard key={article.id} article={article} showTag={index === 0} />
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <Link
            to="/category/meiri-redian"
            className="px-6 py-3 border border-foreground-200 text-foreground-700 font-label text-sm rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部爆料 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </section>

      {/* 热门频道矩阵 */}
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 border border-background-300 text-foreground-600 text-xs font-label rounded-full">
            分类浏览
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热门频道
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            选择你感兴趣的吃瓜频道，精准追踪
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-[1200px] mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-background-50/20 mb-3">
                <i className={`${cat.iconClass} text-xl text-foreground-700 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-background-50 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 mt-3 text-xs font-label text-primary-500 group-hover:text-background-50 transition-colors">
                进入频道 <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* 主编精选大瓜 */}
      <section className="relative py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-[1100px] mx-auto relative">
          <div className="relative rounded-3xl bg-foreground-950 p-6 md:p-10 flex flex-col lg:flex-row gap-6 md:gap-10 overflow-visible">
            <div className="lg:w-[35%] flex-shrink-0 -mt-16 lg:-ml-12 lg:-my-10">
              <div className="rounded-2xl overflow-hidden h-[280px] md:h-[380px] bg-background-300">
                <img
                  src={exclusiveArticles[0]?.imageUrl || articles[0].imageUrl}
                  alt={exclusiveArticles[0]?.title || articles[0].title}
                  title={exclusiveArticles[0]?.title || articles[0].title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-[65%] flex flex-col justify-center">
              <span className="text-5xl md:text-7xl font-heading text-accent-400 leading-none mb-4">
                &ldquo;
              </span>
              <blockquote className="text-base md:text-xl text-background-50 leading-relaxed font-body">
                {exclusiveArticles[0]?.excerpt || '这个行业的信任危机一直在积累，观众越来越聪明，靠人设吃饭的时代正在过去。深度调查揭示的不仅是某一个网红的问题，而是整个产业链条中存在的系统性缺陷。'}
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <div>
                  <p className="text-sm font-label font-medium text-background-50">
                    {exclusiveArticles[0]?.authorName || '深度调查组'}
                  </p>
                  <p className="text-xs text-background-50/50">
                    {exclusiveArticles[0]?.authorRole || '17吃瓜网首席调查记者'}
                  </p>
                </div>
              </div>
              <Link
                to={`/article/${exclusiveArticles[0]?.slug || articles[0].slug}`}
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500/20 text-primary-300 font-label text-sm rounded-lg hover:bg-primary-500/30 transition-colors duration-200 w-fit whitespace-nowrap cursor-pointer"
              >
                阅读全文 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA 订阅引导 */}
      <section id="subscribe" className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative h-[350px] md:h-[450px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20beige%20and%20coral%20abstract%20composition%2C%20soft%20geometric%20shapes%20with%20flowing%20organic%20curves%2C%20dreamy%20atmospheric%20lighting%2C%20luxurious%20editorial%20background%2C%20clean%20minimal%20design%2C%20sophisticated%20texture%2C%20elegant%20color%20gradient%2C%20no%20text%20no%20people&width=1200&height=800&seq=home-cta-left&orientation=landscape"
            alt="订阅17吃瓜网"
            title="订阅每日爆料"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          <div className="absolute bottom-8 left-8 right-8">
            <span className="text-background-50/60 text-xs font-label uppercase tracking-wider">
              不错过任何猛料
            </span>
            <p className="mt-2 text-3xl md:text-5xl font-heading font-black text-background-50 leading-tight">
              每日大瓜
              <br />
              直达邮箱
              <br />
              快人一步
            </p>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center py-14 md:py-20 px-6 md:px-16 text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            订阅17吃瓜
            <br />
            每日爆料推送
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            第一时间获取最新网红黑料、明星塌房、娱乐八卦等热门资讯，从此吃瓜不迷路。
          </p>

          <form
            className="mt-8 w-full max-w-md"
           
            action="http://1wujie.cn/"
            method="POST"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const honeypotEl = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
              if (honeypotEl && honeypotEl.value.trim() !== '') {
                const msgEl = form.querySelector<HTMLElement>('.form-status');
                if (msgEl) {
                  msgEl.textContent = '订阅成功！请查收确认邮件。';
                  msgEl.className = 'form-status mt-4 text-sm font-label text-green-600';
                }
                form.reset();
                return;
              }
              const formData = new FormData(form);
              formData.delete('website_alt');
              try {
                const res = await fetch(form.action, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                });
                const responseText = await res.text();
                let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
                try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
                const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || '';
                const msgEl = form.querySelector<HTMLElement>('.form-status');
                if (res.ok && parsed?.code === 'OK') {
                  if (msgEl) {
                    msgEl.textContent = '订阅成功！请查收确认邮件。';
                    msgEl.className = 'form-status mt-4 text-sm font-label text-green-600';
                  }
                  form.reset();
                } else {
                  if (msgEl) {
                    msgEl.textContent = serverMsg || '订阅失败，请稍后重试。';
                    msgEl.className = 'form-status mt-4 text-sm font-label text-red-500';
                  }
                }
              } catch {
                const msgEl = form.querySelector<HTMLElement>('.form-status');
                if (msgEl) {
                  msgEl.textContent = '网络错误，请稍后重试。';
                  msgEl.className = 'form-status mt-4 text-sm font-label text-red-500';
                }
              }
            }}
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                className="flex-1 px-4 py-3 border border-background-300 rounded-lg text-sm font-label text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                className="homey-honeypot"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="px-6 py-3 bg-foreground-900 text-background-50 font-label text-sm rounded-lg hover:bg-foreground-950 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 justify-center"
              >
                立即订阅 <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="form-status mt-4 text-sm font-label text-foreground-500">
              每日精选爆料，绝无垃圾邮件
            </p>
          </form>
        </div>
      </section>
    </>
  );
}